import { createFileRoute } from "@tanstack/react-router";
import GhidCumparatori from "@/pages/GhidCumparatori";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/de/ghid-cumparatori/")({
  head: () => routeHead("/de/ghid-cumparatori/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <GhidCumparatori />
  );
}
